import {useCallback} from 'react';

import {useCommonEventHook} from 'src/hooks/use-common-event-hook';
import {hidePlatformAlert} from 'src/openapi/admin/apis/PlatformAlertsApi';
import {useAppDispatch} from 'src/store/hooks';

type Props = {
    alertId: number,
    onSuccess: () => void,
    onFail: (error: string) => void,
};

export const useRemoveAlert = ({alertId, onSuccess, onFail}: Props) => {
    const apiDispatch = useAppDispatch();

    const eventAction = useCallback(() => apiDispatch(
        hidePlatformAlert({alertId}),
    ), [alertId, apiDispatch]);

    return useCommonEventHook({eventAction, onSuccess, onFail});
};
